export default __webpack_public_path__ + "static/media/red-light1.198d6b01.jpg";